import {createSelector} from 'reselect';
import includes from 'lodash/includes';

export const getStoreEscrow = ({lang, year, month}) => createSelector(
  state => state.rewards.storeEscrowsById,
  state => state.sites.resources,
  (storeEscrowsById, sites) => {
    const escrowId = Object.keys(storeEscrowsById).find(escrowId => {
      const startDate = storeEscrowsById[escrowId].startDate.date;

      const siteIdForSelectedLang = Object.keys(sites).find(siteId => {
        const site = sites[siteId];
        return includes(site.supportedLanguages, lang);
      });

      const accountSiteId = storeEscrowsById[escrowId].account.siteId;

      return (
        year === startDate.year
          && month === startDate.month
          && accountSiteId === siteIdForSelectedLang
      );
    });

    return escrowId ? storeEscrowsById[escrowId] : null;
  }
);



// WEBPACK FOOTER //
// ./public/pages/Rewards/selectors.js